module.exports = __webpack_public_path__ + "static/bass-4f1fd553a3c8aa10fb3ef2488dbe689c.jpg";